import { Component } from '@angular/core';

@Component({
  selector: 'page-404-layout',
  templateUrl: './page-404-layout.html'
})
export class Page404LayoutComponent { }